import {connect} from 'react-redux';
import {setCurrentPath} from "reducers/NavmenuReducer";
import {storeMeetingSummaryRating} from 'actions/chatAction';
import {getMeetingRatingStatus} from 'actions/videoAction';
import JoinVideoCall from 'views/JoinVideoCall';

const mapStateToProps = ({
  auth: {
    user: {
      id,
      status: {
        experiences: { video },
      },
    },
  },
  mentorship: {
    meetingSummaryRating,
  },
}) => ({
  videoEnabled: video,
  id,
  getMeetingRatingStatus,
  meetingSummaryRating,
});

export default connect(mapStateToProps, {
  setCurrentPath,
  getMeetingRatingStatus,
  storeMeetingSummaryRating,
})(JoinVideoCall);
